import React from 'react'
import {onDragOver, onDragLeave, onDrop} from './DragContainer'

const DropZone = (props) => {

    return <div
        data-element-index={props.elementOrderInGroup}
        className='dropZone empty'
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={(event) => onDrop(event, props.reorderGroups)}
    />
}

export default DropZone